import { Injectable, inject } from '@angular/core';

import { CurrentUser } from 'src/app/auth/models/account.model';
import { AccessEventsService } from './access-events.service';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  accessEvents = inject(AccessEventsService);

  currentUser: CurrentUser | null = null;

  constructor() {
    this.accessEvents.onAccess.subscribe((accessType) => {
      if (accessType === 'logout') {
        this.currentUser = null;
      }
    });
  }

  isAccessAllowedWithPermit(permit: string): boolean {
    return !!this.currentUser?.rolePermits?.find((role) => role.permits.some((p) => p.name === permit));
  }
}
